import React from 'react';

function TimelineItem({ item, formatDate, onItemClick, onToggle, completingId }) {
  const isAssignment = item.type === 'assignment';
  const id = item.id;

  return (
    <div
      className={`timeline-item timeline-item--${item.type} ${item.completed ? 'timeline-item--completed' : ''}`}
      onClick={() => onItemClick(item)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onItemClick(item); } }}
    >
      <div className="timeline-item-icon">
        {isAssignment ? (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 11l3 3L22 4" /><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
          </svg>
        ) : (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" />
          </svg>
        )}
      </div>

      <div className="timeline-item-body">
        <div className="timeline-item-title">{item.title}</div>
        <div className="timeline-item-detail">
          <span className="timeline-item-date">{formatDate(item.date)}</span>
          {item.endeavorName && (
            <>
              <span className="timeline-item-sep">·</span>
              <span className="timeline-item-course">{item.endeavorName}</span>
            </>
          )}
        </div>
      </div>

      {isAssignment && (
        <button
          className={`timeline-toggle ${item.completed ? 'is-complete' : 'is-incomplete'}`}
          onClick={(e) => { e.stopPropagation(); onToggle(item); }}
          disabled={completingId === id}
          aria-label={item.completed ? 'Mark incomplete' : 'Mark complete'}
          title={item.completed ? 'Mark Incomplete' : 'Mark Complete'}
        >
          {item.completed ? (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="10" fill="var(--status-success, #22c55e)" />
              <path d="M8 12l3 3 5-5" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          ) : (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="10" stroke="var(--border-default)" strokeWidth="1.5" fill="none" />
            </svg>
          )}
        </button>
      )}
    </div>
  );
}

function UnifiedTimeline({ items, formatDate, onItemClick, onToggle, completingId, label }) {
  if (!items || items.length === 0) return null;

  return (
    <div className="unified-timeline">
      {label && (
        <div className="timeline-section-label">
          {label}
          <span className="timeline-section-count">{items.length}</span>
        </div>
      )}
      <div className="timeline-list">
        {items.map((item, index) => (
          <TimelineItem
            key={`${item.type}-${item.id}-${index}`}
            item={item}
            formatDate={formatDate}
            onItemClick={onItemClick}
            onToggle={onToggle}
            completingId={completingId}
          />
        ))}
      </div>
    </div>
  );
}

export default React.memo(UnifiedTimeline);
